import { useQuery } from "@tanstack/react-query";

import { handleResponse } from "@/utils/errorResponseHandlers";
import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { authHeader } from "@/utils/headers";

export const useGetWorkspaceMembers = (workspaceId: string, hasAccess: boolean) => {
  const auth = useAuth();
  return useQuery({
    queryKey: ["workspace-members", workspaceId],
    queryFn: async () => {
      const res = await fetch(ENDPOINTS.get_workspace_members(workspaceId), {
        method: "GET",
        headers: authHeader(auth?.userToken ?? ""),
      });

      if (!res.ok) {
        return {
          members: [],
          invitees: [],
        };
      }

      return handleResponse(res);
    },
    enabled: !!workspaceId && hasAccess,
  });
};
